// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contextMenuWrapper[data-v-3180c9b4]{width:100%;border-radius:2px;box-shadow:var(--shadow-picture)}a[data-v-3180c9b4]{display:block}.separator[data-v-3180c9b4]{margin-left:20px;margin-right:20px;margin-top:20px;height:1px;background-color:var(--color-light-grey)}", ""]);
// Exports
module.exports = exports;
